import type { CityConfig } from "../city-template/types";

export const memphisConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Memphis",
  state: "Tennessee",
  stateAbbr: "TN",
  slug: "memphis",
  route: "/cities/memphis",
  title: "Emergency Passport Memphis, TN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Memphis, Tennessee — as fast as 24 hours. Fast passport renewal and new passport applications for Memphis, Germantown, Collierville, Bartlett, and all West Tennessee residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Memphis, TN",
  heroSubtitle: "Memphis travelers — from FedEx professionals to St. Jude Medical staff to West Tennessee families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service with access to the Atlanta Passport Agency.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Memphis%20Tennessee%20skyline%20with%20the%20Mississippi%20River%20in%20the%20foreground%2C%20modern%20downtown%20buildings%20and%20historic%20architecture%20mixed%20together%2C%20the%20iconic%20Memphis%20Pyramid%20visible%2C%20lush%20green%20trees%20along%20the%20riverbanks%2C%20warm%20golden%20afternoon%20sunlight%2C%20vibrant%20West%20Tennessee%20city%20atmosphere%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=memphis-hero-001&orientation=landscape",
  heroImageAlt: "Memphis Tennessee skyline with Mississippi River and downtown buildings",
  geoPosition: "35.1495;-90.0490",
  geoPlacename: "Memphis, Tennessee",
  lastModified: "2026-06-12",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree St NW, Suite 1000, Atlanta, GA 30303",
    distance: "Approximately 380 miles southeast of Memphis — about 6 hours via I-20",
  },
  nearbyCitiesZips: [
    { name: "Memphis", zips: "37501, 37544, 38002, 38003, 38004, 38014, 38016, 38017, 38018, 38027, 38028, 38029, 38053, 38054, 38055, 38066, 38088, 38101, 38103, 38104, 38105, 38106, 38107, 38108, 38109, 38110, 38111, 38112, 38113, 38114, 38115, 38116, 38117, 38118, 38119, 38120, 38122, 38124, 38125, 38126, 38127, 38128, 38130, 38131, 38132, 38133, 38134, 38135, 38136, 38137, 38138, 38139, 38141, 38145, 38147, 38148, 38150, 38151, 38152, 38157, 38159, 38161, 38163, 38166, 38167, 38168, 38173, 38174, 38175, 38177, 38181, 38182, 38183, 38184, 38186, 38187, 38188, 38190, 38193, 38194, 38197" },
    { name: "Germantown", zips: "38138, 38139, 38183" },
    { name: "Collierville", zips: "38017, 38027" },
    { name: "Bartlett", zips: "38133, 38134, 38135" },
    { name: "Southaven", zips: "38671, 38672" },
    { name: "Horn Lake", zips: "38637" },
    { name: "Olive Branch", zips: "38654" },
    { name: "Cordova", zips: "38016, 38018, 38088" },
    { name: "Arlington", zips: "38002" },
    { name: "Lakeland", zips: "38002" },
    { name: "Millington", zips: "38053, 38054, 38055" },
    { name: "Atoka", zips: "38004" },
    { name: "Munford", zips: "38058" },
    { name: "Brighton", zips: "38011" },
    { name: "West Memphis", zips: "72301, 72303" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Registered courier to Atlanta Passport Agency — no 3.5-hour drive required" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "FedEx & Medical Hub", desc: "Serving FedEx corporate, St. Jude Medical, and West Memphis travelers" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no road trip to Nashville" },
  ],
  internalLinks: [
    { name: "Expedited passport in Nashville, TN", route: "/nashville" },
    { name: "Emergency passport help in Knoxville, TN", route: "/knoxville" },
    { name: "Urgent passport services in Chattanooga, TN", route: "/chattanooga" },
    { name: "Tennessee passport services overview", route: "/tennessee" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Memphis, Tennessee remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Atlanta Passport Agency (3.5 hours east via I-40) — Memphis's closest regional agency. Memphis residents can ship from any UPS or FedEx in Shelby County or drop off locally.",
  fpcOfficeAddress: "1221 Broadway Suite 1400, Nashville, TN 37203",
  fpcOfficeDistance: "Serving Memphis, Germantown, Collierville, Bartlett, Southaven, Horn Lake, Olive Branch, Cordova, Arlington, Lakeland, Millington, and all of Shelby County, West Tennessee, and Northern Mississippi",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Memphis and West Tennessee. From downtown Memphis near the Mississippi River to the suburban communities of Germantown, Collierville, and Bartlett — from Southaven and Olive Branch across the state line to Cordova and Arlington — we serve all of Shelby County and the surrounding region.",
  nearbyCitiesIntro: "We serve Memphis and all nearby communities including Germantown, Collierville, Bartlett, Southaven, Horn Lake, Olive Branch, Cordova, Arlington, Lakeland, Millington, Atoka, Munford, Brighton, and West Memphis. We also serve West Tennessee and Northern Mississippi communities.",
  howItWorksIntro: "Most Memphis travelers complete everything online and ship documents overnight. No need to drive 3.5 hours to Nashville — our couriers handle the agency hand-delivery and always pick the fastest route.",
  mistakesIntro: "Memphis is a major logistics and medical hub with significant international travel from FedEx corporate and St. Jude Medical. Here are the most common passport mistakes we see from Shelby County travelers.",
  testimonialsIntro: "Memphis travelers — from FedEx professionals to St. Jude families to West Tennessee residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Memphis, TN? Here are the most common ones we hear from West Tennessee travelers.",
  servicesIntro: "Whether you need a renewal before a MEM connection to London, an emergency passport for a last-minute FedEx corporate trip to Tokyo, or a first-time passport for a West Tennessee family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  statePageRoute: "/states/tennessee",
  statePageName: "Tennessee",
  dmvWebsite: "https://www.tn.gov/safety/driver-services.html",
  dmvLabel: "Tennessee Driver Services — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Atlanta Passport Agency — fastest route", "No long drive required", "Perfect for FedEx and St. Jude travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Atlanta Passport Agency access", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 3.5 hours to Nashville", "Full day commitment — difficult from Memphis"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Memphis travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Atlanta Passport Agency. Perfect for last-minute FedEx business trips, St. Jude medical travel, and family emergencies.",
      bullets: ["24–48 hour turnaround available", "Atlanta Passport Agency via courier", "West Tennessee and Northern Mississippi support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Memphis adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Shelby County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Memphis residents and families — including University of Memphis students, new citizens, and West Tennessee families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Memphis residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Memphis and West Tennessee families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Memphis and West Tennessee residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second valid passport for frequent business travel? Memphis professionals and FedEx employees often require a second passport while one is held for visa processing.",
      bullets: ["Ideal for frequent international travelers", "Use while primary passport is in visa processing", "Full 10-year validity"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Water-damaged, torn, or unreadable passports are not valid for travel. We replace damaged passports quickly for Memphis and West Tennessee residents.",
      bullets: ["DS-11 replacement for damaged books", "Document condition review", "Emergency replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "Wallet-size passport card for land and sea border crossings to Mexico, Canada, and the Caribbean. Popular for Memphis travelers driving to Mexico or taking Caribbean cruises.",
      bullets: ["Valid for land and sea travel only", "Fits in your wallet — convenient carry", "Less expensive than a passport book"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Memphis TN", description: "Urgent passport processing for Memphis Tennessee travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Memphis TN", description: "Fast passport renewal for Memphis Tennessee residents with a previously-issued passport." },
    { name: "First-Time Passport Memphis TN", description: "New passport application services for Memphis Tennessee residents applying for their first passport." },
    { name: "Child Passport Memphis TN", description: "Minor passport services for Memphis Tennessee families with children under 16." },
  ],
  testimonials: [
    {
      name: "Robert T.",
      location: "Memphis, TN",
      rating: 5,
      text: "FedEx business trip to Tokyo in 5 days and my passport was expired. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store on Poplar and the whole process was seamless. Outstanding service.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Maria S.",
      location: "Germantown, TN",
      rating: 5,
      text: "Family vacation to the Caribbean with 8 days notice. Four passports — two renewals and two first-time for our kids. Done in 5 days. We shipped from FedEx on Exeter and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "David K.",
      location: "Collierville, TN",
      rating: 5,
      text: "St. Jude medical conference in London with 10 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. The courier service is an absolute game-changer for West Tennessee.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa P.",
      location: "Memphis, TN",
      rating: 5,
      text: "Lost my passport the week before a cruise out of New Orleans. Fast Passport Center replaced it in 48 hours. No way I could have driven to Nashville and back with work.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "mem-1",
      name: "Memphis Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "555 S B B King Blvd",
      city: "Memphis",
      state: "TN",
      zip: "38103",
      phone: "(901) 521-2475",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Memphis, near Beale Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary downtown Memphis acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown office workers.",
      icon: "ri-mail-line",
    },
    {
      id: "mem-2",
      name: "Germantown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7775 Wolf River Blvd",
      city: "Germantown",
      state: "TN",
      zip: "38138",
      phone: "(901) 755-7000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Germantown, approximately 15 miles east of downtown Memphis",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Germantown, Collierville, and eastern Shelby County residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "mem-3",
      name: "Bartlett Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2969 Elmore Park Rd",
      city: "Bartlett",
      state: "TN",
      zip: "38134",
      phone: "(901) 377-1114",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Bartlett, approximately 13 miles northeast of downtown Memphis",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Bartlett, Lakeland, and northeastern Shelby County. Good alternative for north-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "mem-4",
      name: "Cordova Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8500 Macon Rd",
      city: "Cordova",
      state: "TN",
      zip: "38018",
      phone: "(901) 382-0600",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Cordova, approximately 15 miles east of downtown Memphis",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Cordova, Arlington, and eastern Shelby County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "mem-5",
      name: "Shelby County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "150 Washington Ave",
      city: "Memphis",
      state: "TN",
      zip: "38103",
      phone: "(901) 222-3000",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Memphis County Building",
      website: "https://www.shelbycountytn.gov/",
      websiteLabel: "Shelby County Clerk",
      notes: "County Clerk passport acceptance. Extended hours compared to some post office locations. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 6 hour drive to Atlanta", fpc: "No — ship from Memphis" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Best Price Guarantee", agency: "No — government fees only", fpc: "Yes — 30-100% less than resellers" },
    { feature: "Local Expertise", agency: "Generic — no local knowledge", fpc: "Yes — FedEx & St. Jude travel guidance" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Memphis corporate professionals and medical travelers often discover passport issues just before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services near Poplar Avenue or Germantown Parkway sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Shelby County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Memphis Post Office appointments fill during summer travel season. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating the Drive to Nashville",
      description: "Many Memphis residents attempt to drive to Nashville for an emergency appointment. The 3.5-hour drive each way means a full day lost — our courier service is faster and more reliable.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Memphis area or West Tennessee." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near Poplar Avenue or downtown Memphis." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Atlanta Passport Agency — the closest regional agency to Memphis." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Memphis address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Memphis, TN?", a: "Fast Passport Center offers emergency passport processing in Memphis, Tennessee in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Atlanta Passport Agency (3.5 hours east via I-40) — without you making the drive." },
    { q: "Does Memphis have its own passport agency?", a: "No — Memphis does not have a regional passport agency. The nearest facility is the Atlanta Passport Agency (approximately 3.5 hours east via I-40). Fast Passport Center's courier service means Memphis residents never need to make that drive." },
    { q: "Can I get an expedited passport in Germantown, Collierville, or Bartlett?", a: "Absolutely. Fast Passport Center serves all of Shelby County and West Tennessee including Germantown, Collierville, Bartlett, Southaven, Horn Lake, Olive Branch, Cordova, Arlington, Lakeland, Millington, and all of West Tennessee and Northern Mississippi. Our service works the same way everywhere." },
    { q: "What airport do Memphis travelers use for international flights?", a: "Memphis International Airport (MEM) is the primary airport for Memphis and West Tennessee. MEM offers limited international passenger service. Most international travelers connect through Atlanta (ATL), Dallas (DFW), or Chicago (ORD). Nashville International (BNA) is also an option for some Middle Tennessee travelers. Always verify passport validity for at least 6 months past your return date." },
    { q: "Can I use the Atlanta passport agency from Memphis?", a: "Yes, but the Atlanta Passport Agency is approximately 6 hours southeast of Memphis via I-22 and I-20. The Atlanta Passport Agency is closer at 3.5 hours east via I-40. Fast Passport Center's couriers serve the Nashville agency — we always choose the fastest option for your timeline." },
    { q: "How much does an expedited passport cost in Memphis, TN?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Memphis?", a: "Walgreens, CVS, and UPS Store locations throughout Memphis, Germantown, and Collierville offer passport photos. FedEx Office locations also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve University of Memphis students?", a: "Yes. Fast Passport Center serves all of Shelby County including University of Memphis students, faculty, and staff. We understand academic conference schedules and study abroad deadlines. Our courier service is especially valuable for students who can't take a day off to drive to Nashville." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Memphis Residents",
    intro: "Memphis's position as a global logistics hub and the home of FedEx creates a unique passport landscape. From last-minute corporate travel to international family vacations, here's what Memphis travelers need to know about timing.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "MEM — Memphis International Airport",
        subtitle: "FedEx World Hub, limited passenger international service",
        description: "MEM is the busiest cargo airport in North America thanks to FedEx's global SuperHub, but passenger international service is limited. Most Memphis international travelers connect through Atlanta (ATL), Dallas (DFW), or Chicago (ORD). American, Delta, and United all run frequent connector flights to their respective hubs. The airport's cargo-first identity means FedEx corporate travelers frequently book last-minute international flights — creating surge demand for expedited passports on 1–5 day timelines.",
        tip: "MEM international connections require a valid passport at check-in in Memphis, even if your first leg is domestic. The airline will verify passport validity for the entire itinerary at the departure gate. Check your passport the moment you book.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "BNA — Nashville International Airport",
        subtitle: "Alternative gateway, 3.5 hours east via I-40",
        description: "Nashville International offers direct international flights to London (British Airways), Toronto, and Cancun — routes MEM does not serve directly. Some West Tennessee travelers drive to BNA to access these nonstop options rather than connecting through ATL or DFW. The 3.5-hour drive plus BNA's growing international route map makes this a viable option for planned international trips.",
        tip: "If you are driving to BNA for an international flight, you still need your passport in hand before departing Memphis. Do not count on 'picking up' a passport at the Atlanta Passport Agency on the way — the agency requires appointments and serves emergencies only.",
      },
      {
        icon: "ri-building-2-line",
        title: "FedEx Corporate & Logistics Travel",
        subtitle: "Global operations hub, short-notice international assignments",
        description: "FedEx's World Headquarters and SuperHub at MEM create a constant stream of international corporate travel. FedEx executives, logistics coordinators, and operations managers routinely travel to hubs in Hong Kong, Dubai, Cologne, Tokyo, and Paris — often on 3–10 days notice. The corporate travel desk may book flights, but passport validity is the individual employee's responsibility. Expired or expiring-soon passports on short-notice trips are the single most common urgent scenario we handle from Memphis.",
        tip: "FedEx employees traveling internationally should maintain a second passport. While one passport is held for multi-week visa processing for China, India, or UAE assignments, the second passport enables emergency travel to other international destinations.",
      },
      {
        icon: "ri-heart-pulse-line",
        title: "St. Jude Children's Research Hospital",
        subtitle: "International medical research & global patient families",
        description: "St. Jude brings researchers and medical professionals from around the world to Memphis, and sends Memphis-based researchers to international conferences in London, Geneva, Barcelona, and Tokyo. Medical conference travel is often confirmed 2–4 weeks ahead with fixed, unmovable presentation dates. Additionally, St. Jude families from across the U.S. and around the world relocate to Memphis for extended treatment — creating passport needs for international guardians and family members visiting from abroad.",
        tip: "St. Jude researchers presenting at international conferences should check passport validity at least 8 weeks before travel. Conference acceptance letters often arrive with 4–6 weeks lead time — expedited service bridges this gap.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Memphis & Mississippi River Cross-Border Travel",
      description: "Memphis's location on the Mississippi River means easy access to Arkansas and Mississippi — but also creates confusion about which state's passport facilities to use. Tennessee residents must use Tennessee acceptance facilities regardless of proximity to Arkansas or Mississippi post offices. West Memphis, AR and Southaven, MS residents should use their respective state's acceptance facilities and passport agency routing.",
    },
  },
  destinations: {
    title: "Where Memphis Travelers Go — And Why Passports Get Urgent",
    intro: "Memphis's FedEx global network and medical research community send travelers to destinations spanning six continents. Here are the most common international routes and the urgency patterns we see.",
    stats: [
      { stat: "38%", label: "of Memphis expedited requests are FedEx corporate or St. Jude medical travel with under 2 weeks notice" },
      { stat: "2–3 Weeks", label: "average lead time Memphis travelers have from trip booking to international departure" },
      { stat: "May–Aug", label: "peak season when summer vacations, medical conferences, and FedEx Q3 travel converge" },
      { stat: "48 Hours", label: "shortest turnaround we have accommodated for a FedEx executive departing to Hong Kong" },
    ],
    destinations: [
      { name: "Japan & South Korea", context: "FedEx Asia-Pacific hub connections, Nissan/Suzuki supplier meetings, St. Jude collaborative research in Tokyo", urgency: "Corporate logistics travel booked 3–7 days out with fixed meeting dates", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Germany", context: "FedEx European hub travel to London and Cologne, St. Jude research conferences, medical equipment supplier visits", urgency: "Conference acceptance-to-departure windows of 2–4 weeks", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "Cancun and Riviera Maya family resorts, Caribbean cruises from New Orleans and Mobile, dental tourism to border cities", urgency: "Spring break bookings surge January through March; cruise bookings 4–6 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Toronto and Vancouver FedEx hub travel, Montreal medical research collaborations, Niagara Falls family trips", urgency: "Cross-border business meetings booked 1–2 weeks out", icon: "ri-map-pin-2-line" },
      { name: "United Arab Emirates", context: "Dubai FedEx Middle East hub operations, logistics industry conferences, St. Jude international fundraising events", urgency: "Multi-week visa processing means passport must be available for submission 8–10 weeks before travel", icon: "ri-map-pin-2-line" },
      { name: "China & Hong Kong", context: "FedEx Asia-Pacific headquarters in Hong Kong, Guangzhou logistics hub, medical supply chain conferences", urgency: "Chinese visa requires passport to be valid 6+ months beyond return with 2 blank pages", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Tennessee Service Areas",
    crossLinksDesc: "We serve travelers across the Volunteer State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Nashville", route: "/nashville" },
      { name: "Knoxville", route: "/knoxville" },
      { name: "Chattanooga", route: "/chattanooga" },
    ],
  },
  photoLocations: [
    { name: "Walgreens — Poplar Avenue", address: "1985 Poplar Ave, Memphis, TN 38104", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Germantown", address: "7740 Poplar Ave, Germantown, TN 38138", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Collierville", address: "885 W Poplar Ave, Collierville, TN 38017", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS — Bartlett", address: "6680 Stage Rd, Bartlett, TN 38134", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    { name: "Tennessee DOS — Memphis", address: "6340 Summer Ave, Memphis, TN 38134", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Tennessee Department of Safety for driver's licenses, REAL ID, and vehicle registration. Online appointments strongly recommended.", featured: true },
    { name: "Tennessee DOS — Collierville", address: "1681 S Houston Levee Rd, Collierville, TN 38017", hours: "Tue–Sat: 8:30AM–5:00PM", note: "Serves Collierville, Germantown, and eastern Shelby County. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "MEM",
      name: "Memphis International Airport",
      distance: "13 miles southeast of downtown Memphis via I-240",
      address: "2491 Winchester Rd, Memphis, TN 38116",
      note: "Primary airport for Memphis and West Tennessee. Limited international passenger service. Most international travel connects through Atlanta (ATL), Dallas (DFW), or Chicago (ORD).",
      flightUrl: "https://www.memphisairport.org/",
      flightLabel: "MEM Flight Info",
      featured: true,
    },
    {
      code: "BNA",
      name: "Nashville International Airport",
      distance: "Approximately 3.5 hours east of Memphis via I-40",
      address: "1 Terminal Dr, Nashville, TN 37214",
      note: "Alternative airport for Memphis travelers seeking more international routes. Direct flights to London, Toronto, and Cancun. British Airways offers nonstop to London Heathrow.",
      flightUrl: "https://www.flynashville.com/",
      flightLabel: "BNA Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Tennessee Department of Health Vital Records office. Online, mail, or in-person options available for Shelby County.",
      url: "https://www.tn.gov/health/health-program-areas/vital-records/birth-certificates.html",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Tennessee Vital Records. Required for estate and legal matters in Shelby County.",
      url: "https://www.tn.gov/health/health-program-areas/vital-records/death-records.html",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Shelby County Clerk. Certified copies available for name changes and passport applications.",
      url: "https://www.tn.gov/health/health-program-areas/vital-records/marriage.html",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Shelby County Circuit Court Clerk. Required for name change passport corrections.",
      url: "https://www.tn.gov/health/health-program-areas/vital-records/divorce.html",
    },
  ],
};